import type { SectorPack } from '../schema.js'

/**
 * Sector Pack "Compliance & Regulatorik" (M4, EDIH-Vertrag §4): generische
 * Terminologie und Regeln fuer Compliance-/GRC-Arbeitskontexte.
 * Keine echten Kundendaten, keine erfundenen Rechtsansprueche — Obligationen
 * entstehen immer aus den hinterlegten Policies des Workspace, nicht aus dem Pack.
 */
export const compliancePack: SectorPack = {
  id: 'compliance',
  version: '1.0.0',
  label: 'Compliance & Regulatorik',
  terminology: {
    'Richtlinie': 'Policy (Richtlinie)',
    'Verhaltenskodex': 'Verhaltenskodex (Code of Conduct)',
    'Interessenkonflikt': 'Interessenkonflikt',
    'Meldestelle': 'Meldestelle (Whistleblowing)',
    'Schulung': 'Compliance-Schulung',
    'Risikoanalyse': 'Compliance-Risikoanalyse',
    'Gap-Analyse': 'Gap-Analyse (Soll-Ist)',
    'Massnahmenplan': 'Massnahmenplan (Remediation)',
    'Kontrolle': 'Kontrolle (Internes Kontrollsystem)',
    'Audit': 'Internes Audit',
    'Lieferantenprüfung': 'Lieferantenprüfung (Third-Party Due Diligence)',
    'Datenschutz': 'Datenschutz',
    'Geldwäscherei': 'Geldwäscherei-Prävention (AML)',
    'Sanktionen': 'Sanktionslisten-Prüfung',
    'Verpflichtung': 'Verpflichtung (Obligation)',
    'Ermächtigung': 'Ermächtigungsmatrix',
    'Dokumentation': 'Compliance-Dokumentation',
    'Vier-Augen-Prinzip': 'Vier-Augen-Prinzip',
    'Meldefrist': 'Meldefrist',
    'Richtlinienverstoss': 'Richtlinienverstoss (Policy Breach)',
  },
  taxonomy: {
    topics: [
      'Richtlinienmanagement',
      'Risikoanalyse',
      'Schulung & Awareness',
      'Ueberwachung & Kontrolle',
      'Meldewesen',
      'Dritte & Lieferanten',
    ],
    documentTypes: [
      'Policy',
      'Richtlinie',
      'Weisung',
      'Schulungsunterlage',
      'Audit-Bericht',
      'Massnahmenplan',
    ],
  },
  sourceTypes: ['markdown', 'pdf', 'docx', 'email', 'web'],
  connectors: ['imap', 'rss', 'web'],
  approvedSkills: ['research', 'memory', 'blog', 'newsletter', 'presentation', 'data-analysis'],
  templates: [
    { outputType: 'fachartikel', templateRef: 'compliance/obligation-report' },
    { outputType: 'strategiedokument', templateRef: 'compliance/gap-analyse' },
    { outputType: 'blog_artikel', templateRef: 'compliance/policy-update' },
  ],
  providerRules: { euOnly: true, allowedProviders: ['mistral'] },
  requiredApprovals: ['fachartikel', 'strategiedokument'],
  retentionDefaults: { chatDays: 730, auditDays: 3650 },
  disclaimers: [
    {
      outputType: 'fachartikel',
      text: 'Dieser Bericht wurde maschinell erstellt und stellt keine Rechtsberatung dar. Verpflichtungen und Lücken sind aus den hinterlegten Unterlagen abgeleitet und vor einer Verwendung durch eine qualifizierte Fachperson zu prüfen.',
    },
    {
      outputType: 'strategiedokument',
      text: 'Dieses Dokument wurde maschinell erstellt und stellt keine Rechtsberatung dar. Verpflichtungen und Lücken sind aus den hinterlegten Unterlagen abgeleitet und vor einer Verwendung durch eine qualifizierte Fachperson zu prüfen.',
    },
    {
      outputType: 'blog_artikel',
      text: 'Dieser Artikel wurde maschinell erstellt und stellt keine Rechtsberatung dar. Inhalte sind vor einer Publikation durch eine qualifizierte Fachperson zu prüfen.',
    },
    {
      outputType: 'praesentation',
      text: 'Diese Präsentation wurde maschinell erstellt und stellt keine Rechtsberatung dar. Inhalte sind vor einer Verwendung durch eine qualifizierte Fachperson zu prüfen.',
    },
    {
      outputType: 'newsletter',
      text: 'Dieser Newsletter wurde maschinell erstellt und stellt keine Rechtsberatung dar. Inhalte sind vor einem Versand durch eine qualifizierte Fachperson zu prüfen.',
    },
  ],
  goldenFixtures: [
    {
      scenario: 'policy-set-obligation-gap-report',
      fixtureRefs: ['compliance/policy-set-beispiel-ag.md'],
      expect: 'Obligation- und Gap-Report listet Verpflichtungen mit Quellenverweisen auf das Policy-Set.',
    },
  ],
}
